import React, {FunctionComponent, useContext, useEffect, useState} from 'react';
import {
    InvoiceItemsTableItemRow,
    InvoiceItemsTableItemRowProps
} from '../InvoiceItemsTableItemRow/InvoiceItemsTableItemRow';
import './InvoiceItemsTableGrouping.scss';
import {Item, ItemCategory, ItemSectionSettings} from "../../models/item.model";
import styled from "styled-components";
import {ThemeContext} from "../../context/ThemeContext";

interface InvoiceItemsTableGroupingProps {
    category: ItemCategory,
    itemSection: ItemSectionSettings,
    itemComponent?: FunctionComponent<InvoiceItemsTableItemRowProps>;
}

const InvoiceItemsGrouping = styled.div`
    &.invoice-items-grouping {
        border-color: ${props => props.theme.branding_light_color};

        .invoice-items-grouping-header {
            background: ${props => props.theme.branding_light_color};
            color: ${props => props.theme.text_dark_color};
            border-color: ${props => props.theme.branding_light_color}
        }

        .invoice-item {
            border-color: ${props => props.theme.branding_light_color}
        }

        &.invoice-items-grouping--alternating-colors {
            &:nth-of-type(odd) {
                border-color: ${props => props.theme.branding_dark_color};

                .invoice-items-grouping-header {
                    background: ${props => props.theme.branding_dark_color};
                    color: ${props => props.theme.text_light_color};
                    border-color: ${props => props.theme.branding_dark_color}
                }

                .invoice-item {
                    border-color: ${props => props.theme.branding_dark_color}
                }
            }

            &:nth-of-type(even) {
                border-color: ${props => props.theme.branding_light_color};

                .invoice-items-grouping-header {
                    background: ${props => props.theme.branding_light_color};
                    color: ${props => props.theme.text_dark_color};
                    border-color: ${props => props.theme.branding_light_color}
                }

                .invoice-item, .invoice-item-collapsible {
                    border-color: ${props => props.theme.branding_light_color}
                }
            }
        }
`;

export const InvoiceItemsTableGrouping: FunctionComponent<InvoiceItemsTableGroupingProps> = (props) => {
    const theme = useContext(ThemeContext).theme;
    const {category, itemSection} = props;
    const ItemComponent = props.itemComponent || InvoiceItemsTableItemRow;
    const isAlternatingGroupingColors: boolean = false;


    return category ? (
        <InvoiceItemsGrouping theme={theme}
                              className={`invoice-items-grouping${isAlternatingGroupingColors ? ' invoice-items-grouping--alternating-colors' : ''}`}>
            <div className="invoice-items-grouping-header">
                <div className="invoice-items-grouping-title">
                    <span>{category.title}</span>
                </div>

                {
                    itemSection.is_price_visible
                        ? <div className="invoice-items-grouping-price">
                        </div>
                        : null
                }

                {
                    itemSection.is_unit_tax_amount_visible
                        ? <div className="invoice-items-grouping-unit-tax"></div>
                        : null
                }

                {
                    itemSection.is_quantity_visible
                        ? <div className="invoice-items-grouping-quantity">
                            {category.quantity}
                        </div>
                        : null
                }

                {
                    itemSection.is_taxed_visible
                        ? <div className="invoice-items-grouping-taxed"></div>
                        : null
                }

                {
                    category.is_price_visible && itemSection.is_total_visible
                        ? <div className="invoice-items-grouping-total">
                            {category.total}
                        </div>
                        : null
                }

                {
                    itemSection.is_total_without_tax_visible
                        ? <div className="invoice-items-grouping-amount-with-tax"></div>
                        : null
                }

                {
                    itemSection.is_total_with_tax_visible
                        ? <div className="invoice-items-grouping-amount-with-tax"></div>
                        : null
                }

                {
                    category.description
                        ? <div className="invoice-items-grouping-description">
                            {category.description}
                        </div>
                        : null
                }

            </div>

            {
                category.is_items_visible
                    ? <div className="invoice-items-grouping-items">
                        {
                            category.items.map((item: Item, index) => {
                                if (item.is_visible) {
                                    return <ItemComponent itemSection={itemSection} key={index} item={item}/>
                                }
                                return null;
                            })
                        }
                    </div>
                    : null
            }

        </InvoiceItemsGrouping>
    ) : null;
};